import React, { useEffect, useState } from "react";
import { FaEdit, FaCheck, FaTimes } from "react-icons/fa";
import "./Profile.css";
import ExpOfInterest from "../../pages/CourseRegistrationForm/CourseRegistrationForm";

export default function Profile() {
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const [profileData, setProfileData] = useState({});
  const [editingField, setEditingField] = useState(null);
  const [tempValue, setTempValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");

  const requiredFields = ["country", "city", "fullAddress", "state", "email"];

  const userEmail = user?.email?.trim();
  useEffect(() => {
    if (!userEmail) return;

    let ignore = false;

    fetch(
      `https://agepcoatings.com/getuserbyemail/${encodeURIComponent(userEmail)}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (!ignore && data.success) {
          setProfileData(data.data);
        }
      })
      .catch((err) => console.error("Error fetching profile:", err));

    return () => {
      ignore = true;
    };
  }, [userEmail]);
  // useEffect(() => {
  //   if (user && user.email) {
  //     const trimmedEmail = user.email.trim();
  //     fetch(
  //       `https://agepcoatings.com/getuserbyemail/${encodeURIComponent(
  //         trimmedEmail
  //       )}`
  //     )
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.success) {
  //           setProfileData((prev) => ({ ...prev, ...data.data }));
  //         }
  //       })
  //       .catch((err) => console.error("Error fetching profile:", err));
  //   }
  // }, [user]);

  if (!userEmail) {
    return (
      <div className="container py-5 text-center">
        <h3>No user found. Please log in.</h3>
      </div>
    );
  }

  const getAvatarLetter = () => {
    const name =
      profileData.firstName?.trim() || user.fname || user.email || "";
    return name.charAt(0).toUpperCase();
  };

  const handleEdit = (field, value) => {
    setEditingField(field);
    setTempValue(value && value !== "N/A" ? value : "");
    setError("");
  };

  const handleCancel = () => {
    setEditingField(null);
    setTempValue("");
    setError("");
  };

  const handleSave = async (field) => {
    let valueToSave = tempValue.trim();

    // Lowercase for specific fields
    const lowercaseFields = ["country", "state", "city", "isMember"];
    if (lowercaseFields.includes(field)) {
      valueToSave = valueToSave.toLowerCase();
    }

    // Member Number validation
    if (
      field === "memberNumber" &&
      profileData.isMember === "yes" &&
      !valueToSave
    ) {
      setError("Member Number is required when 'Is Member' is Yes!");
      return;
    }

    // Handle Is Member = No
    if (field === "isMember" && valueToSave === "no") {
      try {
        const trimmedEmail = user.email.trim();
        const res = await fetch(
          `https://agepcoatings.com/courseUser/${encodeURIComponent(
            trimmedEmail
          )}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ isMember: "no", memberNumber: "" }),
          }
        );
        const result = await res.json();
        if (result.success) {
          setProfileData((prev) => ({
            ...prev,
            isMember: "no",
            memberNumber: "",
          }));
          setEditingField(null);
          setError("");
        } else {
          alert(result.message || "Failed to update");
        }
      } catch (err) {
        console.error("Update error:", err);
        alert("Failed to update user");
      }
      return;
    }

    if (requiredFields.includes(field) && !valueToSave) {
      setError(
        `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`
      );
      return;
    }

    try {
      const trimmedEmail = user.email.trim();
      const res = await fetch(
        `https://agepcoatings.com/courseUser/${encodeURIComponent(
          trimmedEmail
        )}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ [field]: valueToSave }),
        }
      );
      const result = await res.json();
      if (result.success) {
        setProfileData((prev) => ({ ...prev, [field]: valueToSave }));
        setEditingField(null);
        setError("");
      } else {
        alert(result.message || "Failed to update");
      }
    } catch (err) {
      console.error("Update error:", err);
      alert("Failed to update user");
    }
  };

  const allProfileFields = {
    personalDetails: [
      { label: "Full Name", key: "firstName" },
      { label: "Gender", key: "gender" },
      { label: "Company", key: "company" },
      { label: "Department", key: "department" },
      { label: "Address Type", key: "addressType" },
      { label: "Full Address", key: "fullAddress" },
      { label: "City", key: "city" },
      { label: "Postal Code", key: "postalCode" },
      { label: "State", key: "state" },
      { label: "Country", key: "country" },
      { label: "GST No", key: "gstNo" },
      { label: "Meals Preferred", key: "mealsPreferred" },
      { label: "Is Member", key: "isMember" },
      // { label: "Previous Cert No", key: "prevCertNo" },
      // { label: "Prev Cert Validity", key: "prevCertValidity", type: "date" },
    ],
    contactDetails: [
      { label: "Home Phone", key: "homePhone" },
      { label: "Mobile", key: "mobileNumber" },
      { label: "Work Phone", key: "workPhone" },
      { label: "Email", key: "email" },
    ],
  };

  const renderField = (label, key, type = "text") => {
    const value =
      profileData[key] ??
      (key === "firstName"
        ? user?.fname
        : key === "email"
        ? user?.email
        : "N/A");

    // Display first letter uppercase for city/state
    // Create a displayValue for showing with first letter uppercase
    const displayValue =
      ["city", "state"].includes(key) && typeof value === "string"
        ? value.charAt(0).toUpperCase() + value.slice(1)
        : value;

    const isEditing = editingField === key;
    const isError =
      (error && isEditing) ||
      (!isEditing &&
        requiredFields.includes(key) &&
        (!value || value === "N/A"));
    // const isEditing = editingField === key;
    // const isError =
    //   (error && isEditing) ||
    //   (!isEditing &&
    //     requiredFields.includes(key) &&
    //     (!value || value === "N/A"));

    const dropdownOptions = {
      gender: ["Male", "Female", "Other"],
      addressType: ["Home", "Office", "Other"],
      country: [
        "afghanistan",
        "albania",
        "algeria",
        "andorra",
        "angola",
        "antigua and barbuda",
        "argentina",
        "armenia",
        "australia",
        "austria",
        "azerbaijan",
        "bahamas",
        "bahrain",
        "bangladesh",
        "barbados",
        "belarus",
        "belgium",
        "belize",
        "benin",
        "bhutan",
        "bolivia",
        "bosnia and herzegovina",
        "botswana",
        "brazil",
        "brunei",
        "bulgaria",
        "burkina faso",
        "burundi",
        "cabo verde",
        "cambodia",
        "cameroon",
        "canada",
        "central african republic",
        "chad",
        "chile",
        "china",
        "colombia",
        "comoros",
        "congo (congo-brazzaville)",
        "costa rica",
        "croatia",
        "cuba",
        "cyprus",
        "czech republic",
        "denmark",
        "djibouti",
        "dominica",
        "dominican republic",
        "ecuador",
        "egypt",
        "el salvador",
        "equatorial guinea",
        "eritrea",
        "estonia",
        "eswatini",
        "ethiopia",
        "fiji",
        "finland",
        "france",
        "gabon",
        "gambia",
        "georgia",
        "germany",
        "ghana",
        "greece",
        "grenada",
        "guatemala",
        "guinea",
        "guinea-bissau",
        "guyana",
        "haiti",
        "honduras",
        "hungary",
        "iceland",
        "india",
        "indonesia",
        "iran",
        "iraq",
        "ireland",
        "israel",
        "italy",
        "jamaica",
        "japan",
        "jordan",
        "kazakhstan",
        "kenya",
        "kiribati",
        "kuwait",
        "kyrgyzstan",
        "laos",
        "latvia",
        "lebanon",
        "lesotho",
        "liberia",
        "libya",
        "liechtenstein",
        "lithuania",
        "luxembourg",
        "madagascar",
        "malawi",
        "malaysia",
        "maldives",
        "mali",
        "malta",
        "marshall islands",
        "mauritania",
        "mauritius",
        "mexico",
        "micronesia",
        "moldova",
        "monaco",
        "mongolia",
        "montenegro",
        "morocco",
        "mozambique",
        "myanmar (burma)",
        "namibia",
        "nauru",
        "nepal",
        "netherlands",
        "new zealand",
        "nicaragua",
        "niger",
        "nigeria",
        "north korea",
        "north macedonia",
        "norway",
        "oman",
        "pakistan",
        "palau",
        "palestine state",
        "panama",
        "papua new guinea",
        "paraguay",
        "peru",
        "philippines",
        "poland",
        "portugal",
        "qatar",
        "romania",
        "russia",
        "rwanda",
        "saint kitts and nevis",
        "saint lucia",
        "saint vincent and the grenadines",
        "samoa",
        "san marino",
        "sao tome and principe",
        "saudi arabia",
        "senegal",
        "serbia",
        "seychelles",
        "sierra leone",
        "singapore",
        "slovakia",
        "slovenia",
        "solomon islands",
        "somalia",
        "south africa",
        "south korea",
        "south sudan",
        "spain",
        "sri lanka",
        "sudan",
        "suriname",
        "sweden",
        "switzerland",
        "syria",
        "taiwan",
        "tajikistan",
        "tanzania",
        "thailand",
        "timor-leste",
        "togo",
        "tonga",
        "trinidad and tobago",
        "tunisia",
        "turkey",
        "turkmenistan",
        "tuvalu",
        "uganda",
        "ukraine",
        "united arab emirates",
        "united kingdom",
        "united states",
        "uruguay",
        "uzbekistan",
        "vanuatu",
        "vatican city",
        "venezuela",
        "vietnam",
        "yemen",
        "zambia",
        "zimbabwe",
      ],
      mealsPreferred: ["Veg", "Non-Veg", "Vegan"],
      isMember: ["yes", "no"],
    };

    const isDropdown = Object.keys(dropdownOptions).includes(key);

    if (isDropdown) {
      return (
        <p className="d-flex align-items-center justify-content-between profile-field">
          <span className="field-label">
            <strong>{label}:</strong>{" "}
            <select
              className={`form-control form-control-sm d-inline-block w-auto ${
                isError ? "border-danger" : ""
              }`}
              // value={value !== "N/A" ? value : ""}
              value={isEditing ? tempValue : value !== "N/A" ? value : ""}
              onChange={(e) => {
                setEditingField(key);
                setTempValue(e.target.value);
                setError("");
              }}
            >
              <option value="">Select {label}</option>
              {/* {dropdownOptions[key].map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))} */}
              {dropdownOptions[key].map((opt) => (
                <option key={opt} value={opt}>
                  {opt.charAt(0).toUpperCase() + opt.slice(1)}
                </option>
              ))}
            </select>
            {isError && <small className="text-danger d-block">{error}</small>}
          </span>
          {isEditing && (
            <span className="field-actions ms-2">
              <FaCheck
                className="action-icon text-success me-2"
                onClick={() => handleSave(key)}
              />
              <FaTimes
                className="action-icon text-danger"
                onClick={handleCancel}
              />
            </span>
          )}
        </p>
      );
    }

    return (
      // <p className="d-flex align-items-center justify-content-between profile-field">
      //   <span className="field-label">
      //     <strong>
      //       {label}{" "}
      //       {requiredFields.includes(key) && (
      //         <span className="text-danger">*</span>
      //       )}
      //       :
      //     </strong>{" "}
      //     {isEditing ? (
      //       <input
      //         type={type}
      //         className={`form-control form-control-sm d-inline-block w-auto ${
      //           isError ? "border-danger" : ""
      //         }`}
      //         value={tempValue}
      //         onChange={(e) => setTempValue(e.target.value)}
      //       />
      //     ) : (
      //       <span className={isError ? "text-danger" : ""}>
      //         {value && typeof value === "string" ? value : "N/A"}
      //       </span>
      //     )}
      //     {isError && isEditing && (
      //       <small className="text-danger d-block">{error}</small>
      //     )}
      //   </span>
      //   <span className="field-actions ms-2">
      //     {isEditing ? (
      //       <>
      //         <FaCheck
      //           className="action-icon text-success me-2"
      //           onClick={() => handleSave(key)}
      //         />
      //         <FaTimes
      //           className="action-icon text-danger"
      //           onClick={handleCancel}
      //         />
      //       </>
      //     ) : (
      //       <FaEdit
      //         className="action-icon text-dark"
      //         onClick={() => handleEdit(key, value)}
      //       />
      //     )}
      //   </span>
      // </p>
      <p className="d-flex align-items-center justify-content-between profile-field">
        <span className="field-label">
          <strong>
            {label}{" "}
            {requiredFields.includes(key) && (
              <span className="text-danger">*</span>
            )}
            :
          </strong>{" "}
          {isEditing ? (
            <input
              type={type}
              className={`form-control form-control-sm d-inline-block w-auto ${
                isError ? "border-danger" : ""
              }`}
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
            />
          ) : (
            <span className={isError ? "text-danger" : ""}>
              {displayValue || "N/A"}
            </span>
          )}
          {isError && isEditing && (
            <small className="text-danger d-block">{error}</small>
          )}
        </span>
        <span className="field-actions ms-2">
          {isEditing ? (
            <>
              <FaCheck
                className="action-icon text-success me-2"
                onClick={() => handleSave(key)}
              />
              <FaTimes
                className="action-icon text-danger"
                onClick={handleCancel}
              />
            </>
          ) : (
            <FaEdit
              className="action-icon text-dark"
              onClick={() => handleEdit(key, value)}
            />
          )}
        </span>
      </p>
    );
  };

  return (
    <div className="profile-container container py-4">
      <div className="mb-3 text-end">
        <button
          className="btn btn-expression rounded-5"
          onClick={() => setShowModal(true)}
        >
          Expression Of Interest
        </button>
      </div>

      <h2 className="profile-heading text-center">My Profile</h2>
      <div className="profile-card shadow-sm rounded-4 p-4">
        <div className="profile-header d-flex align-items-center">
          <div className="avatar rounded-circle d-flex justify-content-center align-items-center me-3">
            {getAvatarLetter()}
          </div>
          <div>
            <h5 className="fw-bold mb-1">
              {profileData.firstName ||
                user?.fname ||
                user?.email ||
                "Unnamed User"}
            </h5>
            <p className="text-muted small mb-1">
              {profileData.email || user?.email}
            </p>
          </div>
        </div>

        <hr />

        <h6 className="fw-bold mt-3 mb-2">Personal Details</h6>
        <div className="row">
          {allProfileFields.personalDetails.map((field) => (
            <div className="col-md-4" key={field.key}>
              {renderField(field.label, field.key, field.type)}
            </div>
          ))}

          {/* Member Number logic */}
          {/* <div className="col-md-4">
            {profileData.isMember === "yes" ? (
              renderField("Member Number", "memberNumber")
            ) : (
              <p className="d-flex align-items-center profile-field">
                <span className="field-label">
                  <strong>Member Number:</strong>{" "}
                  <span className="text-muted">N/A</span>
                </span>
              </p>
            )}
          </div> */}
          {/* Member Number logic */}
          {/* Member Number logic */}
          {profileData.isMember === "yes" && (
            <div className="col-md-4">
              <p className="d-flex flex-column profile-field">
                <span className="field-label mb-1">
                  <strong>
                    Member Number <span className="text-danger">*</span>:
                  </strong>
                </span>

                <input
                  type="text"
                  className={`form-control form-control-sm ${
                    error ? "border-danger" : ""
                  }`}
                  value={
                    editingField === "memberNumber"
                      ? tempValue
                      : profileData.memberNumber || ""
                  }
                  onChange={(e) => {
                    setEditingField("memberNumber");
                    setTempValue(e.target.value);
                    setError("");
                  }}
                />

                {editingField === "memberNumber" && (
                  <div className="mt-1">
                    <FaCheck
                      className="action-icon text-success me-2"
                      onClick={() => handleSave("memberNumber")}
                      style={{ cursor: "pointer" }}
                    />
                    <FaTimes
                      className="action-icon text-danger"
                      onClick={() => handleCancel()}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                )}

                {error && editingField === "memberNumber" && (
                  <small className="text-danger mt-1">{error}</small>
                )}
              </p>
            </div>
          )}
        </div>

        <h6 className="fw-bold mt-3 mb-2">Contact Details</h6>
        <div className="row">
          {allProfileFields.contactDetails.map((field) => (
            <div className="col-md-4" key={field.key}>
              {renderField(field.label, field.key, field.type)}
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <ExpOfInterest />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
